/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EApprenantFichierDeletionReason {
    MANUAL_DELETION = 'MANUAL_DELETION',
    INVALIDATION_AVIS_RESULTATS = 'INVALIDATION_AVIS_RESULTATS'
}


export function EApprenantFichierDeletionReasonFromJSON(json: any): EApprenantFichierDeletionReason {
    return EApprenantFichierDeletionReasonFromJSONTyped(json, false);
}

export function EApprenantFichierDeletionReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EApprenantFichierDeletionReason {
    return json as EApprenantFichierDeletionReason;
}

export function EApprenantFichierDeletionReasonToJSON(value?: EApprenantFichierDeletionReason | null): any {
    return value as any;
}

